import React, { FC } from 'react';
import { InfinityList } from '@components/InfinityList/InfinityList';
import { ToyCard } from '@components/Cards/ToyCard/ToyCard';
import { useRouter } from 'next/router';
import { getToysSortQuery, PageQueries } from '@specs/navigation';
import { useGetPrivateToysInfinity, useGetPublicToysInfinity } from '@hooks/TRPC_Hooks/useGetToys';
import { artist } from '@specs/specs';
import { useSession } from 'next-auth/react';
import { EmptyProfile } from '@components/Pages/ProfilePages/EmptyProfile/EmptyProfile';
interface Props {
  artistId: artist['id'];
}
const limit = 10;
export const ExternalGrid: FC<Props> = ({
  artistId
}) => {
  const {
    status: sessionStatus
  } = useSession();
  const router = useRouter();
  const {
    toysSort,
    query,
    priceSortCurrency
  }: PageQueries = router.query;
  const sort = getToysSortQuery(toysSort);
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    status
  } = (sessionStatus === 'authenticated' ? useGetPrivateToysInfinity : useGetPublicToysInfinity)({
    limit,
    sort,
    query,
    currency: priceSortCurrency,
    artist: artistId
  }, {
    enabled: sessionStatus !== 'loading'
  });
  return <InfinityList enabledRef={undefined} fetchNextPage={fetchNextPage} data={data} hasNextPage={hasNextPage} isFetchingNextPage={isFetchingNextPage} status={status} listClassName={'_toysGrid'} EmptyComponent={() => <EmptyProfile isMyProfile={false} pageType={'toys'} />} data-sentry-element="InfinityList" data-sentry-component="ExternalGrid" data-sentry-source-file="ExternalGrid.tsx">
            {item => <ToyCard key={item.id} {...item} />}
        </InfinityList>;
};